var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1665 14C15.1665 14.6451 14.6438 15.1666 13.9998 15.1666C13.3558 15.1666 12.8331 14.6451 12.8331 14V2.33329C12.8331 1.68813 13.3558 1.16663 13.9998 1.16663C14.6438 1.16663 15.1665 1.68813 15.1665 2.33329V14ZM17.7785 4.13148C18.0737 3.55864 18.7783 3.33581 19.35 3.62981C23.2455 5.64464 25.6663 9.61714 25.6663 14.0003C25.6663 20.4321 20.4327 25.667 13.9997 25.667C7.56667 25.667 2.33301 20.4321 2.33301 14.0003C2.33301 9.61714 4.75384 5.64464 8.65051 3.62981C9.22101 3.33464 9.92567 3.55748 10.222 4.13148C10.5183 4.70314 10.2932 5.40664 9.72151 5.70298C6.60301 7.31414 4.66634 10.4933 4.66634 14.0003C4.66634 19.1465 8.85351 23.3336 13.9997 23.3336C19.1458 23.3336 23.333 19.1465 23.333 14.0003C23.333 10.4933 21.3963 7.31414 18.279 5.70298C17.7062 5.40664 17.4822 4.70314 17.7785 4.13148Z",
    fill: "white",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_695_6749",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 24,
    height: 25
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1665 14C15.1665 14.6451 14.6438 15.1666 13.9998 15.1666C13.3558 15.1666 12.8331 14.6451 12.8331 14V2.33329C12.8331 1.68813 13.3558 1.16663 13.9998 1.16663C14.6438 1.16663 15.1665 1.68813 15.1665 2.33329V14ZM17.7785 4.13148C18.0737 3.55864 18.7783 3.33581 19.35 3.62981C23.2455 5.64464 25.6663 9.61714 25.6663 14.0003C25.6663 20.4321 20.4327 25.667 13.9997 25.667C7.56667 25.667 2.33301 20.4321 2.33301 14.0003C2.33301 9.61714 4.75384 5.64464 8.65051 3.62981C9.22101 3.33464 9.92567 3.55748 10.222 4.13148C10.5183 4.70314 10.2932 5.40664 9.72151 5.70298C6.60301 7.31414 4.66634 10.4933 4.66634 14.0003C4.66634 19.1465 8.85351 23.3336 13.9997 23.3336C19.1458 23.3336 23.333 19.1465 23.333 14.0003C23.333 10.4933 21.3963 7.31414 18.279 5.70298C17.7062 5.40664 17.4822 4.70314 17.7785 4.13148Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_695_6749)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/iconLogout.9f3e66c36d27d3342937fdd47381f510.svg";
export { ForwardRef as ReactComponent };